import React from "react"
import NotFoundFallback from "../components/fallback/404-fallback";

const NotFound = () => {

    return <NotFoundFallback/>
}
export default NotFound;
